import FormType from "./formType";

const ConditionalRender = ({ children, condition }) => {
  return condition.includes(FormType()) ? children : null;
};

export default ConditionalRender;
